<template>
    <app-ghost-mode>
        <!-- stage one of post aNewItem -->
        <div class="container jumbotron screen-center">
            <div class="negotiate-header pt-3 text-center">
                <h3 class="md-small-text">Upload More Item Photos</h3>
            </div>
            <!-- Alert Messages -->
            <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                <dd class="col-12">
                    <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                </dd>
            </dl>
            <form enctype="multipart/form-data">
                <!-- stage heading -->
                <div class="row mt-5">
                    <div class="col-lg-10 col-md-8 col-sm-6 col-12">
                        <h4 class="small-text">Add Photos</h4>
                    </div>
                    <div class="col-lg-2 col-md-4 col-sm-6 col-12">
                        <button @click.prevent="uploadPhotos" class="loadn btn btn-dark-green h3 form-control">
                            Upload <i class="fas fa-cloud-upload-alt"></i>
                        </button>
                    </div>
                </div>
                <!-- select image -->
                <div class="row">
                    <div class="col-12">
                        <div class="card text-center text-muted">
                            <div class="card-body item-upload">
                                <label for="file-input">
                                    <i class="far fa-plus-square fa-10x clickable"></i>
                                </label>
                                <input @change="uploadProceed" type="file" multiple accept="image/jpeg, image/png, image/gif" hidden id="file-input"/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <!-- preview images -->
            <div class="row my-3">
                <div class="col-12">
                    <div class="card text-center text-muted">
                        <div class="card-body p-0 form-inline mx-auto">
                            <div v-for="(x, i) in previewArrCheck" :key="i" class="mx-1 preview-box">
                                <template v-if="previewArr.length > 0">
                                    <img :src="x.path" class="rounded preview-img" />
                                    <i @click="removePhoto(i)" class="fas fa-trash-alt p-1 preview-trash rounded text-danger"></i>
                                </template>
                                <i v-else class="far fa-image fa-5x"></i>
                            </div>
                        </div>
                        <div class="card-footer">
                            Total photos uploaded: {{photosArr.length}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "AddPhotos",
    props: ['itemId'],
    data() {
        return {
            price: '',
            msg: '',
            color: 'danger',
            previewArr: [],
            photosArr: [],
            previewImg: '',
        }
    },
    methods: {
        ...mapActions(['photosPreview', 'addMoreItemPhotos', 'toggleModifyItemPhotos']),
        uploadPhotos() {
            this.color = "danger"
            if(this.photosArr.length === 0){ this.msg = "Upload at least one photo of your item"; return }
            // temp. save the image previews on store 
            this.photosPreview(this.previewArr)

            // prepare the properties needed to save the photos in the items db 
            let editItemObj = {
                userId: this.user._id,
                itemId: this.itemId,
                photos: this.photosArr
            }
            // send object to vuex 
            this.addMoreItemPhotos(editItemObj)
            .then((data) => {
                if(!data.error){ this.color = "success" }
                this.msg = data.msg
            }).catch((e) => {
                this.color = "danger"
                this.msg = "Uploading photos failed! Try again"
            })
        },
        uploadProceed(e) {
            let images = e.target.files
            for(let x=0; x < images.length; x++){
                let reader = new FileReader()
                reader.readAsDataURL(images[x])
                reader.onload = e => {
                    this.previewImg = e.target.result;
                    let previewObj = {
                        path: this.previewImg,
                        main: false
                    }
                    this.previewArr.push(previewObj)
                    let photoObj = {
                        path: images,
                        main: false
                    }
                    this.photosArr.push(photoObj)
                }   
            }
        },
        removePhoto(photoId) {
            // remove photo from variable arrays
            this.previewArr.splice(photoId, 1)
            this.photosArr.splice(photoId, 1)
        },
    },
    computed: {
        ...mapGetters(['user']),
        previewArrCheck() {
            if(this.previewArr.length > 0){
                return this.previewArr
            }
            return 3
        }
    },
    components: {
        appGhostMode: GhostMode
    },
    mounted() {
        this.previewArr = []
    },
    destroyed() {
        this.toggleModifyItemPhotos(true)
    }
}
</script>